export enum CalendarType {
    Undefined = "Undefined",
    FiveDays = "FiveDays",
    SixDays = "SixDays"
}
